import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { MdEdit } from "react-icons/md";
import { Box, Button, styled, Dialog, DialogTitle, DialogActions, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CandidateProAction } from "../../../Redux/action/CandidateProAction";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const ApplyKeyExperience = () => {
  const { userResult } = useSelector((state) => state.Auth);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({
    currentlyWorkingCompanyName: "",
    currentDesignation: "",
    jobProfile: "",
    roleInHiring: ""
  });

  const {
    currentlyWorkingCompanyName,
    currentDesignation,
    jobProfile,
    roleInHiring
  } = data;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const userInfo = useSelector((state) => state.Profile.result);

  console.log(userInfo, "userInfoPro")
  let userData = userInfo;

  useEffect(() => {
    if (userData) {
      setData({ ...userData });
    }
  }, [userData]);

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const candidateId = userResult?.userid;;
  const dispatch = useDispatch();
  const handleSubmit = (e) => {
    e.preventDefault();

    let content = {
      candidateId,
      currentlyWorkingCompanyName,
      currentDesignation,
      jobProfile,
      roleInHiring
    };

    dispatch(CandidateProAction(content));

  };
  const location = useLocation();
  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Update Your Key Experiences.
        </BootstrapDialogTitle>
        <form onSubmit={handleSubmit}>
          <Box
            sx={{
              width: 500,
              maxWidth: '100%',
            }}
          >
            <TextField fullWidth label="Currently Working Company Name" value={currentlyWorkingCompanyName} name="currentlyWorkingCompanyName"

              onChange={handleInputChange} />
            <TextField fullWidth label="Current Designation" value={currentDesignation} name="currentDesignation"

              onChange={handleInputChange} />
            <TextField fullWidth label="JobProfile" name="jobProfile" value={jobProfile} onChange={handleInputChange} />
            <TextField fullWidth label="RoleInHiring" name="roleInHiring" value={roleInHiring} onChange={handleInputChange} />

          </Box>
          <DialogActions>
            <Button autoFocus type="submit">
              Save changes
            </Button>
          </DialogActions>
        </form>
      </BootstrapDialog>

      <div className="apply-profile-card12">
        <div className='edit-button'>
          <div className='overview'>
            <span style={{ fontWeight: "bold" }}>Key Experiences</span>

            {location.state === null ? <><span onClick={handleClickOpen}><MdEdit /></span></> : console.log("data")}
          </div>
        </div>
        <div className='key_hr'> <hr /></div>

        <div className="contact_info-body">
          <div className="contact_key">
            <div className='contact_key'>Currently</div>
            <div className="">
              {userInfo.currentlyWorkingCompanyName !== null && userInfo.currentlyWorkingCompanyName !== "" ? <p className="key_ex candidate_key_width">{userInfo.currentlyWorkingCompanyName}</p> : <p className="candidate_Warning_data fill-data">Current Company</p>}

            </div>
          </div>

        </div>
        <div className='key_hr'> <hr /></div>

        <div className="contact_info-body">
          <div className="contact_key">
            <div className='contact_key'>Current Designation</div>
            <div className="">
              {userInfo.currentDesignation !== null && userInfo.currentDesignation !== "" ? <p className="key_ex candidate_key_width">{userInfo.currentDesignation}</p> : <p className="candidate_Warning_data fill-data">Designation</p>}

            </div>
          </div>

        </div>
        <div className='key_hr'> <hr /></div>

        <div className="contact_info-body">
          <div className="contact_key">
            <div className='contact_key'>Job profile</div>
            <div className="">
              {userInfo.jobProfile !== null && userInfo.jobProfile !== "" ? <p className="key_ex candidate_key_width">{userInfo.jobProfile}</p> : <p className="candidate_Warning_data fill-data">Job Profile</p>}

            </div>
          </div>

        </div>
        <div className='key_hr'> <hr /></div>

        <div className="contact_info-body">
          <div className="contact_key">
            <div className='contact_key'>Role In Hiring</div>
            <div className="">
              {userInfo.roleInHiring !== null && userInfo.roleInHiring !== "" ? <p className="key_ex candidate_key_width">{userInfo.roleInHiring}</p> : <p className="candidate_Warning_data fill-data">Role In Hiring</p>}

            </div>
          </div>

        </div>

      </div></>
  )
}

export default ApplyKeyExperience